// app/javascript/controllers/tooltip_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tooltip"]
  static values = {
    options: { type: Object, default: {} }
  }
  
  connect() {
    // Initialize on controller connection
    this.initializeTooltips()
    //console.log("tooltip initialized!")
  }
  
  disconnect() {
    // Clean up tooltips when the controller is disconnected
    this.disposeTooltips()
  }
  
  initializeTooltips() {
    // Store tooltips instances for later disposal
    this.tooltipInstances = []
    
    // If specific elements are targeted with tooltip-target
    if (this.hasTooltipTarget) {
      this.tooltipTargets.forEach(element => {
        this.createTooltip(element)
      })
    }
  }
  
  createTooltip(element) {
    // Create the tooltip with default options merged with any provided options
    const options = {...this.defaultOptions, ...this.optionsValue}
    const tooltip = new window.bootstrap.Tooltip(element, options)
    
    // Store reference for cleanup
    this.tooltipInstances.push(tooltip)
  }
  
  disposeTooltips() {
    // Properly dispose of all tooltip instances
    if (this.tooltipInstances) {
      this.tooltipInstances.forEach(tooltip => {
        tooltip.dispose()
      })
      this.tooltipInstances = []
    }
  }
  
  // Default options for Bootstrap tooltips
  get defaultOptions() {
    return {
      trigger: 'hover focus',
      boundary: 'clippingParents',
      animation: true
    }
  }
}